import 'jquery-confirm';

jQuery(function ($) {
    var bm = window.bm || {};

    $('.tx-lemken-sso-handler-customer-switch select').change(function () {
        $(this).parents("form").submit();
    });

    var $spinner = jQuery('.tx-lemken-sso-handler .spinner');

    if (typeof customerContactUri !== "undefined") {
        jQuery(document).ready(function () {
            $.colorbox({href: customerContactUri});
        });
    }

    function showSpinner() {
        $('body').append($spinner);
        $spinner.show();
    }

    function hideSpinner() {
        $spinner.hide();
    }


    var modificationContactSelectBox = $('.mandatory-modification-contact').parent();
    var trainingInfoRecipientSelectBox = $('.mandatory-training-info-recipient').parent();
    var selectedTrainingInfoRecipientValue,
        selectedModificationContactValue;

    modificationContactSelectBox.focus(function () {
        selectedModificationContactValue = jQuery(this).val();
    });
    modificationContactSelectBox.change(function () {
        if (jQuery(this).val() === '') {
            showNoticeModal(jQuery(this).data('notice'));
            jQuery(this).val(selectedModificationContactValue);
        }
    });

    trainingInfoRecipientSelectBox.focus(function () {
        selectedTrainingInfoRecipientValue = jQuery(this).val();
    });
    trainingInfoRecipientSelectBox.change(function () {
        if (jQuery(this).val() === '') {
            showNoticeModal(jQuery(this).data('notice'));
            jQuery(this).val(selectedTrainingInfoRecipientValue);
        }
    });

    $('.missing-role-delete').click(function () {
        showNoticeModal(jQuery(this).data('notice'));
        return false;
    });

    function showNoticeModal(message) {
        window.jconfirm({
            title: '<span class="notice-modal-title">' + $('#notice-modal-content .modal-title').html() + '</span>',
            content: '<div class="notice-modal-message">' + message + '</div>',
            backgroundDismiss: true,
            columnClass: 'col-xs-12 col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 ',
            draggable: false,
            buttons: {
                ok: {
                    btnClass: 'right',
                    text: $('#notice-modal-content .modal-button-ok').html()
                }
            }
        });
    };

    function bind_event_buttons() {
        jQuery('#exit-without-saving').on('click', function (event) {
            window.location = listUri;
            return false;
        });

        /*
                $(".customerContactForm").submit(function(e) {
                    var $form = $(this);
                    showSpinner();
                    //replace default ajax call so we can catch and display errors
                    $.ajax({
                        type: "POST",
                        url: $form.attr('action'),
                        data: $form.serialize(),
                        success: function(data) {
                            var $errorHtml = $('<div />').html(data).find('.error');
                            if ($errorHtml.length > 0) {
                                hideSpinner();
                                $form.find('.error').remove();
                                $form.prepend($errorHtml);
                                $.colorbox.resize();
                            } else {
                                //redirect to list view if there was not error
                                window.location = listUri;
                            }
                        }
                    });

                    e.preventDefault();
                });
        */
        $('#exit-and-invite').on('click', function (event) {
            $('#customerContactUtility').val(1);
        });

        $('#exit-and-invite-and-save').on('click', function (event) {
            $('#customerContactUtility').val(1);
        });

        $('#exit-and-delete').on('click', function (event) {
            var customerContact = $('#customerContactForDelete').val();
            window.location = ajaxDeleteUri + "&tx_lemssohandler_adminsso%5BcustomerContact%5D=" + customerContact;
            return false;
        });
    };

    $('#delete-modal-trigger').click(function (e) {
        e.preventDefault();
        window.jconfirm({
            title: $('#delete-modal-content .modal-title').html(),
            content: $('#delete-modal-content .modal-content').html(),
            columnClass: 'col-xs-12 col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 ',
            draggable: false,
            buttons: {
                cancel: {
                    btnClass: 'left',
                    text: $('#delete-modal-content .modal-button-cancel').html(),
                },
                hide: {
                    text: $('#delete-modal-content .modal-button-hide').html(),
                    btnClass: 'btn btn-danger right',
                    action: function (hideButton) {
                        window.location.href = $('#delete-modal-content .modal-action-hide').attr('href');
                    }
                },
                remove: {
                    text: $('#delete-modal-content .modal-button-remove').html(),
                    btnClass: 'btn btn-danger right',
                    action: function (removeButton) {
                        window.location.href = $('#delete-modal-content .modal-action-delete').attr('href');
                    }
                }
            }
        });
    });

    var usedFilters = {},
        customerContactUids = [],
        hiddenCustomerContactUidsInput = $('input[name="tx_lemssohandler_adminsso[customerContacts]"]');

    for (var i in bm.customerContacts) {
        customerContactUids.push(bm.customerContacts[i].uid);
    }
    hiddenCustomerContactUidsInput.val(customerContactUids.join(','));

    function hasCustomerContactPropertyValue(customerContact, property, value) {
        if (customerContact.hasOwnProperty(property)) {
            return customerContact[property] == value;
        } else {
            return false;
        }
    }

    function hasCustomerContactRole(customerContact, roleValue) {
        if (customerContact.applicationRoles.hasOwnProperty(roleValue)) {
            return true;
        } else if (isNaN(roleValue)) {
            for (var uid in customerContact.applicationRoles) {
                var application = customerContact.applicationRoles[uid].application;
                if (application === roleValue) {
                    // Not active (see template)
                    return false;
                }
            }
            // Active
            return true
        } else {
            return false;
        }
    }

    function isValueEmpty(value) {
        return value === '';
    }

    function filterCustomerContacts() {
        var uids = [];
        if (window.hasOwnProperty('bm') && bm.hasOwnProperty('customerContacts')) {
            for (var i in bm.customerContacts) {
                var customerContact = bm.customerContacts[i],
                    valid = true;
                for (var filterName in usedFilters) {
                    if (isValueEmpty(usedFilters[filterName])) {
                        continue;
                    }
                    if (filterName === 'state' || filterName === 'role') {
                        if (!hasCustomerContactPropertyValue(customerContact, filterName, usedFilters[filterName])) {
                            valid = false;
                            break;
                        }
                    } else {
                        if (!hasCustomerContactRole(customerContact, usedFilters[filterName])) {
                            valid = false;
                            break;
                        }
                    }
                }
                if (valid) {
                    uids.push(customerContact.uid);
                }
            }
        }
        return uids;
    }

    $('.filter-customer-contacts select').change(function () {
        var $select = $(this),
            value = $select.val(),
            filterName = $select.data('filter');

        usedFilters[filterName] = value;

        var uids = filterCustomerContacts();
        hiddenCustomerContactUidsInput.val(uids.join(','));

        jQuery('.filter-item').hide();
        jQuery('.filter-item .filter-item-delimiter').remove();
        for (var i = 0, maxi = uids.length; i < maxi; i++) {
            var $ccEl = jQuery('.customer-contact-' + uids[i]);
            $ccEl.show();
            $ccEl.append('<div class="col-xs-12 filter-item-delimiter"><hr/></div>');
        }
        jQuery('.filter-item:visible:last .filter-item-delimiter').remove();

    });

    bind_event_buttons();
    $(document).bind('cbox_complete', function () {
        //bind_event_buttons();
    });

    $('.setEmailAsUsername').click(function () {
        $('#username').val($(this).data('email'));
        $('#usernameTxt').html($(this).data('email'));
        $(this).hide();
        $('.resetUsername').show();
    });

    $('.resetUsername').click(function () {
        $('#username').val($(this).data('username'));
        $('#usernameTxt').html($(this).data('username'));
        $(this).hide();
        $('.setEmailAsUsername').show();
    });
});
